import { render, staticRenderFns } from "./addPatientForm.vue?vue&type=template&id=7ed51339&scoped=true&"
import script from "./addPatientForm.vue?vue&type=script&lang=js&"
export * from "./addPatientForm.vue?vue&type=script&lang=js&"
import style0 from "./addPatientForm.vue?vue&type=style&index=0&id=7ed51339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed51339",
  null
  
)

export default component.exports